import React from 'react';
export function SimpleCellFormatter(_a) {
  var value = _a.value;
  return React.createElement("div", {
    title: String(value)
  }, value);
}